import { useEffect, useState } from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

const Partners = () => {
  const partList = [
    {
      one: "/images/part1.webp",
      two: "/images/part20.webp",
      three: "/images/part9.webp",
    },
    {
      one: "/images/part2.webp",
      two: "/images/part19.webp",
      three: "/images/part10.webp",
    },
    {
      one: "/images/part3.webp",
      two: "/images/part18.webp",
      three: "/images/part11.webp",
    },
    {
      one: "/images/part4.webp",
      two: "/images/part17.svg",
      three: "/images/part8.svg",
    },
    {
      one: "/images/part5.webp",
      two: "/images/part16.webp",
      three: "/images/part12.webp",
    },
    {
      one: "/images/part6.webp",
      two: "/images/part15.webp",
      three: "/images/part7.webp",
    },
    {
      one: "/images/part7.webp",
      two: "/images/part14.webp",
      three: "/images/part20.webp",
    },
    {
      one: "/images/part8.svg",
      two: "/images/part13.webp",
      three: "/images/part3.webp",
    },
    {
      one: "/images/part10.webp",
      two: "/images/part12.webp",
      three: "/images/part16.webp",
    },
    {
      one: "/images/part11.webp",
      two: "/images/part1.webp",
      three: "/images/part5.webp",
    },
  ];

  const [count, setCount] = useState(2);

  useEffect(() => {
    if (window.innerWidth >= 768) {
      setCount(8);
    } else {
      setCount(2);
    }

    window.addEventListener("resize", () => {
      if (window.innerWidth >= 768) {
        setCount(8);
      } else {
        setCount(2);
      }
    });
  }, []);
  return (
    <div id="partners" className="relative w-full h-full py-14 lg:py-28 xl:pb-36">
      <div className="text-black relative w-full h-full px-[calc((100%-var(--container))/2)]  mx-auto ">
        <p className="font-light leading-normal 2xl:text-6xl 2xl:mb-3">집치울때와</p>
        <p className="font-light leading-none 2xl:text-6xl">함께하는 파트너사</p>
        <div className="relative w-full h-full"></div>
      </div>
      <div data-aos="fade-up" className=" relative w-full h-full py-10">
        <Swiper
          spaceBetween={30}
          centeredSlides={false}
          loop={true}
          slidesPerView={count}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
          }}
          speed={1500}
          loopAdditionalSlides={1}
          modules={[Autoplay]}
          className="mySwiper swiper-wrapper relative w-full h-full mb-5"
        >
          {partList.map((v, i) => (
            <SwiperSlide key={i} className=" relative w-full h-full overflow-hidden">
              <div className="relative w-full h-full border px-3 py-6">
                <img
                  className="!relative w-auto max-w-20 h-8 lg:max-w-32 lg:h-14 mx-auto object-contain"
                  alt="집치울때 협력 파트너사 로고"
                  loading="lazy"
                  src={v.one}
                  width={500}
                  height={500}
                />
              </div>
              <div className="relative w-full h-full border px-3 py-6 my-5">
                <img
                  className="!relative w-auto max-w-20 h-8 lg:max-w-32 lg:h-14 mx-auto object-contain"
                  alt="집치울때 협력 파트너사 로고"
                  loading="lazy"
                  src={v.two}
                  width={500}
                  height={500}
                />
              </div>
              <div className="relative w-full h-full border px-3 py-6">
                <img
                  className="!relative w-auto max-w-20 h-8 lg:max-w-32 lg:h-14 mx-auto object-contain"
                  alt="집치울때 협력 파트너사 로고"
                  loading="lazy"
                  src={v.three}
                  width={500}
                  height={500}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Partners;
